/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserRole {
    FAMILY = 'family',
    PRIVATE_PATIENT = 'private-patient',
    PATIENT = 'patient',
    CAREGIVER_PATIENT = 'caregiver-patient',
}
